module.exports = __webpack_public_path__ + "img/Apoptosis-CECA_10X_CC.0aaf6912.png";